import React, { useEffect, useState } from 'react';
import '../../styles/AdminUsersTab.css';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export default function AdminUsersTab() {
  const [items, setItems] = useState([]);
  const [msg, setMsg] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [form, setForm] = useState({ id: '', pw: '', role: 'viewer' });

  // 1. 목록 로드
  async function load() {
    try {
      const res = await fetch(`${API_BASE}/api/admin_user_list.php`, { credentials: 'include' });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || 'Load failed');
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      setMsg(e.message);
    }
  }

  useEffect(() => { load(); }, []);

  // 2. 메시지 알림
  const showMsg = (text) => {
    setMsg(text);
    setTimeout(() => setMsg(''), 3000);
  };

  // 3. 모달 열기
  const openModal = (user = null) => {
    if (user) {
      setIsEditMode(true);
      setForm({ id: user.id, pw: '', role: user.role });
    } else {
      setIsEditMode(false);
      setForm({ id: '', pw: '', role: 'viewer' });
    }
    setShowModal(true);
  };

  // 4. 저장 (Create / Update)
  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const res = await fetch(`${API_BASE}/api/admin_user_upsert.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.error || 'Save failed');
      
      showMsg(isEditMode ? 'User updated ✅' : 'User created ✅');
      setShowModal(false);
      load();
    } catch (e) {
      showMsg(e.message);
    }
  }

  // 5. 삭제
  async function handleDelete(id) {
    if (!window.confirm(`정말 '${id}' 사용자를 삭제하시겠습니까?`)) return;
    try {
      const res = await fetch(`${API_BASE}/api/admin_user_delete.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ id }),
      });
      if (!res.ok) throw new Error('Delete failed');
      showMsg('User deleted ✅');
      load();
    } catch (e) {
      showMsg(e.message);
    }
  }

  return (
    <div className="admin-tab-content">
      {msg && <div className={`admin-toast ${msg.includes('✅') ? 'success' : 'error'}`}>{msg}</div>}

      <div className="admin-list-header">
        <button onClick={() => openModal()} className="admin-btn primary">+ NEW ACCOUNT</button>
      </div>

      <section className="admin-card">
        <div className="card-head">
          <h3>USER MANAGEMENT</h3>
          <span className="card-dot"></span>
        </div>
        <div className="admin-user-list">
          {items.map(u => (
            <div key={u.id} className="user-admin-item">
              <div className="user-info-main">
                <div className="user-avatar">{u.id.charAt(0).toUpperCase()}</div>
                <div>
                  <p className="user-id-text">{u.id}</p>
                  <span className={`user-role-badge ${u.role}`}>{u.role}</span>
                </div>
              </div>
              <div className="user-actions">
                <button onClick={() => openModal(u)} className="icon-btn edit">✎</button>
                <button onClick={() => handleDelete(u.id)} className="icon-btn del">✕</button>
              </div>
            </div>
          ))}
          {items.length === 0 && <p className="empty-msg">No users found.</p>}
        </div>
      </section>

      {showModal && (
        <div className="admin-modal-overlay">
          <div className="admin-card modal-card">
            <div className="card-head">
              <h3>{isEditMode ? 'EDIT USER' : 'NEW USER'}</h3>
              <button onClick={() => setShowModal(false)} className="close-btn">&times;</button>
            </div>
            <form className="admin-form" onSubmit={handleSubmit}>
              <div className="input-group">
                <label>User ID</label>
                <input 
                  value={form.id} 
                  onChange={e => setForm({...form, id: e.target.value})}
                  disabled={isEditMode} 
                  required 
                />
              </div>
              <div className="input-group">
                <label>Password</label>
                <input 
                  type="password" 
                  value={form.pw}
                  onChange={e => setForm({...form, pw: e.target.value})}
                  placeholder={isEditMode ? "변경 시에만 입력" : "비밀번호 설정"} 
                  required={!isEditMode}
                />
              </div>
              <div className="input-group">
                <label>Role</label>
                <select value={form.role} onChange={e => setForm({...form, role: e.target.value})}>
                  <option value="viewer">VIEWER</option>
                  <option value="admin">ADMIN</option>
                </select>
              </div>
              <div className="form-actions">
                <button type="submit" className="admin-btn primary" style={{flex: 1}}>SAVE</button>
                <button type="button" onClick={() => setShowModal(false)} className="admin-btn secondary">CANCEL</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}